import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import './CompareButton.css';

interface CompareButtonProps {
  playerSteamId: string | undefined;
  isDark?: boolean;
}

const CompareButton: React.FC<CompareButtonProps> = ({ playerSteamId, isDark }) => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  
  const handleCompareClick = () => {
    if (!playerSteamId) return;
    
    // If the user is viewing their own profile, just navigate to compare with their ID
    if (user?.steamID === playerSteamId) {
      navigate(`/compare?players=${playerSteamId}`);
      return;
    }
    
    // If the user is viewing someone else's profile, add both IDs to compare
    if (user?.steamID && playerSteamId) {
      navigate(`/compare?players=${user.steamID},${playerSteamId}`);
      return;
    }
    
    // If user is not logged in, just navigate to compare with the viewed player's ID
    navigate(`/compare?players=${playerSteamId}`);
  };
  
  return (
    <div className={`compare-button-container ${isDark ? 'dark' : ''}`}>
      <button 
        className="compare-button" 
        onClick={handleCompareClick}
        aria-label="Sammenlign spillere"
      >
        Sammenlign
      </button>
    </div>
  );
};

export default CompareButton;